import PrimusLib from '~/assets/ws';
import { LocalStorage } from '~/helpers';
import apiURLs from '~/api/url';

let primus;

/**
 * @param options {{
 *   apiBaseURL: string
 * }}
 */
const initPrimus = (options) => {
  const baseURL = options?.apiBaseURL || '';

  primus = new PrimusLib(
    `${apiURLs.getWS(baseURL)}?token=${LocalStorage.getToken()}`
  );
};

const getPrimus = () => primus;

export { getPrimus, initPrimus };
